import { prepareRequest } from "../index.js";
import { setParamsToURL } from "../index.js";
import { USER_API_URL_LIST } from "../routes/user/index.js";
import axios from "axios";

async function login(username, password) {
  let response = await prepareRequest(
    null,
    {
      method: "POST",
      url: setParamsToURL(USER_API_URL_LIST.LOGIN_URL),
      post: {
        Value: username,
        Password: password,
      },
    },
    true
  );

  return response;
}
async function controlDomain(domain) {
  let config = {
    method: "get",
    url: `https://checkout.ofiscom.net/Auth/DomainControl?Domain=${domain}`,
    headers: {
      "content-type": "application/json",
    },
    data: {},
  };
  return await axios.request(config);
}

export { login, controlDomain };
